"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importDefault(require("@/constants"));
const DeleteConfirmationModal = ({ onDelete, sectionName }) => {
    const onClose = () => {
        components_1.modalEvents.remove();
    };
    const onDeleteConfirm = () => {
        onDelete();
        onClose();
    };
    return (react_1.default.createElement(components_1.ModalTemplate, { title: constants_1.default.managePrograms.detail.deleteSection, onClose: onClose, ariaLabel: constants_1.default.managePrograms.detail.deleteSection, width: 630 },
        react_1.default.createElement("p", null, constants_1.default.managePrograms.detail.areYouSureYouWantToDeleteSection(sectionName)),
        react_1.default.createElement(components_1.ModalTemplate.Footer, null,
            react_1.default.createElement(components_1.Button, { title: constants_1.default.managePrograms.detail.cancel, variant: "primary", onClick: onClose, ariaLabel: "cancel" }),
            react_1.default.createElement(components_1.Button, { title: constants_1.default.managePrograms.detail.delete, variant: "ghost", onClick: onDeleteConfirm, ariaLabel: "delete" }))));
};
exports.default = DeleteConfirmationModal;
